const map = {
	"./activity_rewards/view.html": 3974,
	"./campaign/view.html": 1642,
	"./daily_quests/view.html": 8731,
	"./faction_campaign/view.html": 8937,
	"./game_modes_usage/view.html": 4656,
	"./idle_quests/view.html": 3034,
	"./player_managers/view.html": 5608,
	"./searching_tool/view.html": 413,
	"./second_campaign/view.html": 668,
	"./spies/view.html": 4276,
	"./story_quests/view.html": 1587,
	"./supply/view.html": 7397,
	"./weekly_quests/view.html": 1735
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2736;